import React from 'react'
import { t } from '../../../i18n'
import ConfirmModal, { ConfirmAction } from './ConfirmModal'

interface PublishConfirmModalProps {
  onPublish: () => void
  onPublishAndSync?: () => void
  onClose: () => void
  title?: string
  children: React.ReactNode
}

const PublishConfirmModal = ({
  onPublish,
  onPublishAndSync,
  onClose,
  title,
  children
}: PublishConfirmModalProps) => {
  const actions: ConfirmAction[] = onPublishAndSync
    ? [
        {
          label: t('versioning.publish'),
          className: 'btn btn-secondary me-2',
          onConfirm: onPublish
        },
        {
          label: t('versioning.publish_and_sync'),
          className: 'btn btn-primary',
          onConfirm: onPublishAndSync
        }
      ]
    : [
        {
          label: t('versioning.publish'),
          className: 'btn btn-primary',
          onConfirm: onPublish
        }
      ]

  return (
    <ConfirmModal
      title={title ?? t('versioning.publish_confirm_title')}
      confirmActions={actions}
      onClose={onClose}
    >
      {children}
    </ConfirmModal>
  )
}

export default PublishConfirmModal
